// extracted by mini-css-extract-plugin
module.exports = {"kittyGallery":"styles_kittyGallery__1dz2N","avatar":"styles_avatar__30voY","menu":"styles_menu__1JZEE"};